module.exports = __webpack_public_path__ + "img/jamie_young.c0fcb4d.png";